export default {
  bind: (el) => {
    el.classList.add('highlight');
  },
  update: (el, binding) => {
    if (binding.value) {
      el.classList.add('highlight-active');
    } else {
      el.classList.remove('highlight-active');
    }
  },
};
